import type { Event } from "@apps/gwservice/types"
import { icsDateUtc, icsEscape, icsFold } from "./ics-format"
import { lexicalToText } from "./lexical-to-text"

export const buildEventIcs = (event: Event, deepLinkUrl: string): string => {
  const desc = [lexicalToText(event.description), deepLinkUrl].filter(Boolean).join("\n\n")
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//gwservice//EN",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:event-${event.id}@gwservice`,
    `DTSTAMP:${icsDateUtc(new Date())}`,
    `DTSTART:${icsDateUtc(event.date)}`,
    event.endTime ? `DTEND:${icsDateUtc(event.endTime)}` : undefined,
    `SUMMARY:${icsEscape(event.title)}`,
    event.location ? `LOCATION:${icsEscape(event.location)}` : undefined,
    `DESCRIPTION:${icsEscape(desc)}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].filter((line): line is string => line !== undefined)
  return lines.map(icsFold).join("\r\n") + "\r\n"
}
